module.exports = __webpack_public_path__ + "img/add-circle.1605399f.svg";